const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'bmp'];

const isImageFormat = (extension) => {
  try {
    return imageExtensions.includes(extension.toLowerCase());
  } catch {
    return false;
  }
};

export default isImageFormat;
